module.exports = __webpack_public_path__ + "img/banner-principal.beec2bdb.png";